import React from "react";
import COLORS from "../../constants/colors";
import TopBarActions from "./TopBarActions";

export default function FlowTopBar({
  title,
  onPrev,
  onStar,
  onSkip,
  onHome,
  disablePrev = false,
}) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        marginBottom: "1.2rem",
        gap: "1rem",
      }}
    >
      <div
        style={{
          fontSize: "1.05rem",
          fontWeight: 700,
          color: COLORS.text,
          lineHeight: 1.5,
        }}
      >
        {title}
      </div>

      <TopBarActions
        onPrev={onPrev}
        onStar={onStar}
        onSkip={onSkip}
        onHome={onHome}
        disablePrev={disablePrev}
      />
    </div>
  );
}